'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

const LoginInit: React.FC = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.clear();
  }, []);

  return null;
};

export default LoginInit;
